const sortOptionsMock = ['Last updated', 'Alphabetical', 'Condition class'];

export default sortOptionsMock;
